export enum Attribute {
    CONFIGURATION = 'configuration',
    SOURCE = 'source',
    AUTOPLAY = 'autoplay',
    MUTED = 'muted',
    FULLSCREEN = 'fullscreen',
    FULLWINDOW = 'fullwindow',
    FLUID = 'fluid',
    DEVICE_TYPE = 'device-type',
    MOBILE = 'mobile',
    TV = 'tv',
    TV_FOCUS = 'tv-focus',
    MOBILE_ONLY = 'mobile-only',
    MOBILE_HIDDEN = 'mobile-hidden',
    TV_ONLY = 'tv-only',
    TV_HIDDEN = 'tv-hidden',
    USER_IDLE = 'user-idle',
    USER_IDLE_TIMEOUT = 'user-idle-timeout',
    NO_AUTO_HIDE = 'no-auto-hide',
    DISABLED = 'disabled',
    INERT = 'inert',
    HIDDEN = 'hidden',
    PAUSED = 'paused',
    ENDED = 'ended',
    VOLUME_LEVEL = 'volume-level',
    CASTING = 'casting',
    LOADING = 'loading',
    STREAM_TYPE = 'stream-type',
    LIVE = 'live',
    LIVE_ONLY = 'live-only',
    LIVE_HIDDEN = 'live-hidden',
    LIVE_THRESHOLD = 'live-threshold',
    DVR_THRESHOLD = 'dvr-threshold',
    REMAINING = 'remaining',
    REMAINING_WHEN_LIVE = 'remaining-when-live',
    SHOW_DURATION = 'show-duration',
    SEEK_OFFSET = 'seek-offset',
    MENU = 'menu',
    MENU_OPENED = 'menu-opened',
    MENU_CLOSE_ON_INPUT = 'menu-close-on-input',
    ARIA_LABEL = 'aria-label',
    ARIA_LIVE = 'aria-live',
    ARIA_CHECKED = 'aria-checked',
    HAS_AUDIO = 'has-audio',
    HAS_SUBTITLES = 'has-subtitles',
    HAS_ERROR = 'has-error',
    HAS_FIRST_PLAY = 'has-first-play',
    HAS_TITLE = 'has-title',
    CAST_STATE = 'cast-state',
    TRACK_TYPE = 'track-type',
    SHOW_OFF = 'show-off',
    PLAYING_AD = 'playing-ad',
    SHOW_AD_MARKERS = 'show-ad-markers',
    CLICKTHROUGH = 'clickthrough',
    PROPERTY = 'property',
    VALUE = 'value'
}
